import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { shareService } from '../services/shareService';

export function useRevokeShare() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('shares');

  return useMutation({
    mutationFn: (id: string) => shareService.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shares'] });
      toast.success({ title: t('toasts.revokeSuccess') });
    },
    onError: () => {
      toast.danger({ title: t('toasts.revokeError') });
    },
  });
}
